import * as React from 'react';
const SvgArrowRightFromLine = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path fill="#fff" fillOpacity={0.01} d="M0 0h24v24H0z" />
    <path
      fill="currentColor"
      d="M13.11 15.178c-.2-.2-.2-.51 0-.71l1.48-1.472H8.5c-.28 0-.5-.22-.5-.5v-1.001c0-.28.22-.5.5-.5h6.09l-1.48-1.472c-.2-.2-.2-.51 0-.71l.71-.711c.2-.2.51-.2.71 0l3.18 3.182c.39.39.39 1.021 0 1.412l-3.18 3.182c-.2.2-.51.2-.71 0l-.71-.71zM5.73 4.04c.09.05.17.12.22.22.03.06.05.14.05.25V19.2c0 .28 0 .42-.05.53a.52.52 0 0 1-.22.22c-.06.03-.12.04-.22.05h-.99c-.11 0-.19-.02-.25-.05a.52.52 0 0 1-.22-.22.5.5 0 0 1-.05-.18V4.8c0-.28 0-.42.05-.53.05-.09.12-.17.22-.22C4.38 4 4.52 4 4.8 4h.4c.28 0 .42 0 .53.05z"
    />
  </svg>
);
export default SvgArrowRightFromLine;
